module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section07_05_american-village-eefdcf66b8b09792150749559a17d108.jpg";